import { useState, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { MailX } from "lucide-react";
import { API } from "@/App";
import axios from "axios";
import { toast } from "sonner";
import { unsubscribePush, pushSupported } from "@/lib/push";

export const ContactPrefsCard = ({ token }) => {
  const [optedOut, setOptedOut] = useState(false);
  const headers = { headers: { Authorization: `Bearer ${token}` } };

  useEffect(() => {
    axios.get(`${API}/push/status`, headers).then((r) => setOptedOut(!!r.data.opted_out)).catch((e) => console.error(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount
  }, []);

  const toggle = async (allowContact) => {
    const newOptedOut = !allowContact;
    try {
      await axios.post(`${API}/push/contact-opt`, { opted_out: newOptedOut }, headers);
      setOptedOut(newOptedOut);
      if (newOptedOut) {
        localStorage.setItem("notifications_enabled", "false");
        if (pushSupported()) {
          try { await unsubscribePush(token); } catch (e) { /* already removed server-side */ }
        }
        toast.success("You're unsubscribed from all emails & reminders. Your account and garden are untouched 🌼");
      } else {
        toast.success("Welcome back — you'll hear from us again 💛");
      }
    } catch (e) {
      toast.error("Couldn't update contact preferences");
    }
  };

  return (
    <Card className="glass-card rounded-3xl border-0 mb-6" data-testid="contact-prefs-card">
      <CardContent className="p-6">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl bg-stone-100 dark:bg-stone-800 flex items-center justify-center">
              <MailX className="w-6 h-6 text-stone-500" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-heading text-lg font-semibold text-foreground">All Contact</h3>
              <p className="text-sm text-muted-foreground">
                {optedOut
                  ? "You're unsubscribed from everything — no emails, no reminders"
                  : "One switch controls it all — turn off to stop every email and reminder instantly"}
              </p>
            </div>
          </div>
          <Switch
            checked={!optedOut}
            onCheckedChange={toggle}
            data-testid="contact-opt-switch"
            aria-label="Allow all contact"
          />
        </div>
      </CardContent>
    </Card>
  );
};
